export default __webpack_public_path__ + "static/media/GrandDragonLotto.3c39dc42.png";